import { ServiceResponse } from '@sdbn/common';
import { AttachDetachDetails } from '../model/attach-detach-details';
import { AppServerAPI } from '@sdbn/common';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TruckDetails } from '../model/visit-details';

@Injectable({
  providedIn: 'root'
})
export class TransportAttachDetachService {

  constructor(private appServerAPI: AppServerAPI) { }

  getAttachDetachDetails(transportId: number): Observable<AttachDetachDetails> {
    return this.appServerAPI.execute<AttachDetachDetails>('/client/control/attach-detach/details', { id: transportId });
  }

  getCurrentVisits(): Observable<TruckDetails[]> {
    return this.appServerAPI.execute<TruckDetails[]>('/client/control/attach-detach/current-visits', {});
  }

  getTargetsForTrailerSwap(): Observable<TruckDetails[]> {
    return this.appServerAPI.execute<TruckDetails[]>('/client/control/attach-detach/targets-for-trailer-swap', {});
  }

  save(details: AttachDetachDetails): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/control/attach-detach/save', details);
  }
}
